import type { ResidentRow } from "../types"

/**
 * Footer "Total Selected" — matches `transferResident()` / `transfer_all`:
 * full current page selected and overall total > 10 → show grand total; else selected id count.
 */
export function transferSelectionDisplayedCount(
  selectedIds: number[],
  rows: Pick<ResidentRow, "application_id">[],
  totalAcrossPages: number,
): number {
  const transferAllEligible =
    selectedIds.length > 0 &&
    totalAcrossPages > 10 &&
    rows.length > 0 &&
    selectedIds.length === rows.length
  return transferAllEligible ? totalAcrossPages : selectedIds.length
}
